import * as _ from 'lodash';
import { select, Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { SponsorGroupListService } from 'app/sponsor-group/services/sponsor-group-list.service';

import { resetSponsorGroupList } from 'app/sponsor-group/features/sponsor-group/sponsor-group.actions';
import { selectSponsorGroupList } from 'app/sponsor-group/features/sponsor-group/sponsor-group.selectors';

import { SPONSOR_GROUP_LIST_TOKEN } from 'app/sponsor-group/tokens/sponsor-group-list.token';

class SponsorGroupList {
    public takeUntilSubject: Subject<any> = new Subject();

    public list$ = this.store.pipe(
        select(selectSponsorGroupList),
        takeUntil(this.takeUntilSubject)
    );

    constructor(
        public store: Store,
        public sponsorGroupListService: SponsorGroupListService
    ) {
        this.list$.subscribe(list => {
            this.sponsorGroupListService.list = list;
        });
    }

    public destroy() {
        this.takeUntilSubject.next(null);
        this.takeUntilSubject.complete();

        this.store.dispatch({
            type: resetSponsorGroupList.type
        });
    }
}

export const SponsorGroupListFactory = (
    store: Store,
    sponsorGroupListService: SponsorGroupListService
) => {
    return new SponsorGroupList(store, sponsorGroupListService);
}

export const sponsorGroupListProvider = {
    provide: SPONSOR_GROUP_LIST_TOKEN,
    useFactory: SponsorGroupListFactory,
    deps: [Store, SponsorGroupListService]
};
